import { API_CONFIG } from '../brands/default/config';
import { URLLOCATIONS } from '../brands/default/services';
import axios from '../components/_generic/axiosSplunk/axiosSplunk';
import httpCommonHeaders from '../helpers/httpCommonHeaders';
// import { setLocations } from '../redux/actions/locations';

export const getLocations = async () => {
  const { data } = await axios(URLLOCATIONS, {
    headers: {
      brand: API_CONFIG.BRAND_HEADER,
      headers: httpCommonHeaders(),
      webapp: true,
    },
    method: 'GET',
    withCredentials: true,
  });

  return data;
};

export const getStaticLocations = async () => {
  return [
    {
      _score: null,
      brand: 'wowcher',
      countryCode: 'gb',
      description: null,
      domain: null,
      id: 277_172,
      latLon: { lat: 57.133_333, lon: -2.1 },
      name: 'Aberdeen',
      region: 'Scotland',
      shortName: 'aberdeen',
      siteGroup: null,
      status: null,
    },
    {
      _score: null,
      brand: 'wowcher',
      countryCode: 'gb',
      description: null,
      domain: null,
      id: 277_173,
      latLon: { lat: 55.833_332_061_767_58, lon: -4.25 },
      name: 'Glasgow',
      region: 'Scotland',
      shortName: 'glasgow',
      siteGroup: null,
      status: null,
    },
    {
      _score: null,
      brand: 'wowcher',
      countryCode: 'gb',
      description: null,
      domain: null,
      id: 277_174,
      latLon: { lat: 55.950_000_762_939_45, lon: -3.200_000_047_683_716 },
      name: 'Edinburgh',
      region: 'Scotland',
      shortName: 'edinburgh',
      siteGroup: null,
      status: null,
    },
    {
      _score: null,
      brand: 'wowcher',
      countryCode: 'gb',
      description: null,
      domain: null,
      id: 277_176,
      latLon: { lat: null, lon: null },
      name: 'Travel',
      region: 'Scotland',
      shortName: 'travel',
      siteGroup: null,
      status: null,
    },
  ];
};
